// extracted by mini-css-extract-plugin
module.exports = {"timer":"styled_timer__3C-gp"};